module.exports = __webpack_public_path__ + "img/sample_order_product2.39ea9b51.png";